export const DASHBOARD_FILTERS = {
  OVERVIEW: "overview",
  SPECIALS: "specials",
  REVIEWS: "reviews",
  PROFILE: "profile",
  CATERING: "catering",
  CONTRACT: "contract",
  LOGOUT: "logout" 
};
